import React, { useState, useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// --- CSS & Assets ---
import "./App.css";
import notificationMp3 from "./HHC/assets/mixkit-software-interface-start-2574.wav";

// --- Material UI Components & Icons ---
import { Box, Typography, Paper, Modal, Button } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined"; // Not explicitly used but kept to avoid breaking
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";

// --- Configurations ---
import { API_URL } from "./HHC/components/Config/api";
// import PackageList from "./HHC/components/ADMIN/Package/Package Management/PackageList";
// import PackageManagementList from "./HHC/components/ADMIN/Package/Package Management List/PackageManagementList";

// =====================================================================
// STANDARD COMPONENT IMPORTS (Replaced Lazy Loading)
// =====================================================================

import NotFound from "./HHC/NotFound";
import Loginextentions from "./HHC/components/Login/Loginextentions";
import UserDetails from "./HHC/components/UserDeatilsForm/UserDetails";

// HD Module
import HD_Dashboard from "./HHC/components/HD/HD_Dashboard/HD_Dashboard";
import Dashboard from "./HHC/components/HD/Dashboard/Dashboard";
import Viewservice from "./HHC/components/HD/Viewservice";
import Addservice from "./HHC/components/HD/Addservice";
import Ongoingservice from "./HHC/components/HD/Ongoingservice/Ongoingservice";
import Professional from "./HHC/components/HD/Dashboard/Professional";
import ServiceRequest from "./HHC/components/HD/Servicerequest/ServiceRequest";
import Enquiries from "./HHC/components/HD/Enquiries/Enquiries";
import Schedule from "./HHC/components/HD/Professional/Schedule";
import Membership from "./HHC/components/HD/Membership/Membership";
import ProfRequest from "./HHC/components/HD/ProfRequest/ProfRequest";
import ShiftHandover from "./HHC/components/HD/ShiftHandover/ShiftHandover";
import ConsentDetails from "./HHC/components/HD/Viewservice/ConsentForm/ConsentDetails";

// HR Module
import HRDashboard from "./HHC/components/HR/Dashboard/HRDashboard";
import ManageProfile from "./HHC/components/HR/Profile/ManageProfile";
import AddProfessional from "./HHC/components/HR/Profile/AddProfessional";
import Interview from "./HHC/components/HR/Interview/Interview";
import Candidates from "./HHC/components/HR/Onboarding/Candidates";
import Employee from "./HHC/components/HR/Employee/Employee";
import Attendence from "./HHC/components/HR/Attendence/Attendence";
import SystemUser from "./HHC/components/HR/SystemUser/SystemUser";
import ExternalProf from "./HHC/components/HR/ExternalProfessional/ExternalProf";
import CareCoordinator from "./HHC/components/HR/CareTaker/CareTaker";

// ADMIN Module
import AdminDashboard from "./HHC/components/ADMIN/AdminDashboard";
import Permission from "./HHC/components/ADMIN/Permission";

// ADMIN - Reports
import AdminReport from "./HHC/components/ADMIN/Reports/AdminReport";
import EnquiryReport from "./HHC/components/ADMIN/Reports/EnquiryReport";
import ConsultantReport from "./HHC/components/ADMIN/Reports/ConsultantReport";
import HospitalReport from "./HHC/components/ADMIN/Reports/HospitalReport";
import MonthlyReport from "./HHC/components/ADMIN/Reports/MonthlyReport";
import PaymentCancellation from "./HHC/components/ADMIN/Reports/PaymentCancellation";
import RefundAmount from "./HHC/components/ADMIN/Reports/RefundAmount";
import JobClosure from "./HHC/components/ADMIN/Reports/JonClosure";
import ConsentForm from "./HHC/components/ADMIN/Reports/ConsentForm";
import RefundReports from "./HHC/components/ADMIN/Reports/RefunReports";
import ClinicalReports from "./HHC/components/ADMIN/Reports/ClinicalReports";
import PatientFeedbackReport from "./HHC/components/ADMIN/Reports/Patientfeedback/PatientFeedbackReport";
import ProfessionalFeedbackReport from "./HHC/components/ADMIN/Reports/ProfessionalFeedbackReport";
import LongTermReport from "./HHC/components/ADMIN/Reports/LongTermReport/LongTermReport";
import ShiftHandoverReport from "./HHC/components/ADMIN/Reports/ShiftHandOverReport";

// ADMIN - HCM
import ManageService from "./HHC/components/ADMIN/HCM/ManageService";
import ManageHospital from "./HHC/components/ADMIN/HCM/ManageHospital";
import ManageFeedBack from "./HHC/components/ADMIN/HCM/ManageFeedBack";
import ManagePayment from "./HHC/components/ADMIN/HCM/ManagePayment";
import LoginEmployees from "./HHC/components/ADMIN/HCM/LoginEmployees";
import AllocatedList from "./HHC/components/ADMIN/HCM/ProfessionalAllocation/AllocatedList";
import ProfessionalDetails from "./HHC/components/ADMIN/HCM/ProfessionalDetails";
import { Insurance } from "./HHC/components/ADMIN/HCM/Insurance/Insurance"; // Named Import converted
import ClosureRevalidation from "./HHC/components/ADMIN/HCM/ClosureRevalidation/ClosureRevalidation";
import ConsultantList from "./HHC/components/ADMIN/HCM/Consultant/ConsultantList";
import ManageConsultant from "./HHC/components/ADMIN/HCM/Manage Consultant/ManageConsultant";
import Patientblacklist from "./HHC/components/ADMIN/HCM/Patientblacklist";
import LongTearmForm from "./HHC/components/ADMIN/HCM/LongtermForm/LongtermForm";
import MedicalForm from "./HHC/components/ADMIN/HCM/LongtermForm/MedicalForm";

// ADMIN - ACCOUNT
import AccountDashboard from "./HHC/components/ADMIN/ACCOUNT/AccountDashboard";
import NewExportReceipt from "./HHC/components/ADMIN/ACCOUNT/NewExportReceipt";
import ExportInvoice from "./HHC/components/ADMIN/ACCOUNT/ExportInvoice";
import PaymentWithProfessional from "./HHC/components/ADMIN/ACCOUNT/PaymentWithProfessional";
import PaymentPatient from "./HHC/components/ADMIN/ACCOUNT/PaymentPatient";
import Cashfree from "./HHC/components/ADMIN/ACCOUNT/Cashfree";
import PendingPayment from "./HHC/components/ADMIN/ACCOUNT/PendingPayment";
import DayPrintBHV from "./HHC/components/ADMIN/ACCOUNT/DayPrintBHV";
import JobClosureAccount from "./HHC/components/ADMIN/ACCOUNT/JobClosureAccount";
import ProfessionalUnit from "./HHC/components/ADMIN/ACCOUNT/ProfessionalUnit";
import OnlineTransaction from "./HHC/components/ADMIN/ACCOUNT/OnlineTransaction";
import PaymentUTR from "./HHC/components/ADMIN/ACCOUNT/PaymentUTR";

// Payment Payout Module
import ProfRequestPayout from "./HHC/components/ADMIN/PaymentPayout/ProfRequestPayout/ProfRequestPayout";
import ProcessPayout from "./HHC/components/ADMIN/PaymentPayout/ProcessPayout/ProcessPayout";
import ApprovedPayoutList from "./HHC/components/ADMIN/PaymentPayout/ApprovedPayoutList/ApprovedPayoutList";
import PaymentpayoutReport from "./HHC/components/ADMIN/PaymentPayout/Report/PaymentpayoutReport";

// Attendance Module
import ManageAttendance from "./HHC/components/Attendance/ManageAttendance";
import AtteDashboard from "./HHC/components/Attendance/AtteDashboard";
import ManageReports from "./HHC/components/Attendance/ManageReports";

// Management & Analytics Dashboard
import ManagementDashboard from "./HHC/components/ManagementDashboard/MDashboard";
import MM2Dashboard from "./HHC/components/M2Dashboard/MM2Dashboard";
import Home from "./HHC/components/HHC_Analytics/Home";

// Clinical Governance
import Clinicalgov from "./HHC/components/ADMIN/ClinicalNew/Clinicalgov";
import Header from "./HHC/components/Clinical/Header";
import ClosureDetails from "./HHC/components/Clinical/ClosureDetails";

// Hospital Module
import HospitalDashboard from "./HHC/components/Hospitals/Dashboard/HospitalDashboard";

// HR Partner Module
import HrDashboard from "./HHC/components/HrPartner/Dashboard/HrDashboard";
import ManageProfessionals from "./HHC/components/HrPartner/Professionals/ManageProfessionals";
import AddProfPartner from "./HHC/components/HrPartner/Professionals/AddProfPartner";
import Servicedetails from "./HHC/components/HrPartner/ServiceDetails/Servicedetails";

// Consultant Module
import ConsultantLogin from "./HHC/components/Consultant/ConsultantLogin/ConsultantLogin";
import ReferredPatientDetails from "./HHC/components/Consultant/ConsultantForm/ReferredPatientDetails";
import ReferredPatient from "./HHC/components/Consultant/ConsultantForm/ReferredPatient";

// Other Features
import Refund from "./HHC/components/ADMIN/Refund/Refund";
import PhysioMiles from "./HHC/components/ADMIN/PhysioMilestone/PhysioMiles";
import AddPhysioMiles from "./HHC/components/ADMIN/PhysioMilestone/AddPhysioMiles";
import SupervisorVisitor from "./HHC/components/ADMIN/Supervisorvistior/SupervisorVisitor";
import DemoPurpose from "./HHC/components/ADMIN/DemoPurpose";
import CallModal from "./HHC/components/Callmodal/CallModal";
import ManualDialer from "./HHC/components/Callmodal/ManualDialer";

// Privacy Policy
import TermsCondition from "./HHC/components/PrivacyPolicy/TermsCondition";
import CancellationRefundPolicy from "./HHC/components/PrivacyPolicy/CancellationRefundPolicy";
import ContactInfo from "./HHC/components/PrivacyPolicy/ContactInfo";
import AboutUs from "./HHC/components/PrivacyPolicy/AboutUs";
import MDashboard from "./HHC/components/ManagementDashboard/MDashboard";

// =====================================================================
// MAIN APP COMPONENT
// =====================================================================

function App() {
  const [globalChatCount, setGlobalChatCount] = useState(null);
  const audioRef = useRef(null);

  const isLoggedIn1 = localStorage.getItem("isLoggedIn");
  const isLoggedIn = localStorage.getItem("isLoggedIn");

  // ==========================================
  // 🎵 AUDIO PLAY & CHAT COUNT LOGIC
  // ==========================================
useEffect(() => {
  audioRef.current = new Audio(notificationMp3);
  let interval;

  const fetchChatCount = async () => {
    const token = localStorage.getItem("token");
    const currentIsLoggedIn = localStorage.getItem("isLoggedIn");

    // 1. Prevent API hit on Login page OR if token is missing
    if (
      !token ||
      currentIsLoggedIn !== "true" ||
      window.location.pathname === "/"
    ) {
      return; // Skip execution if not properly authenticated
    }

    try {
      const response = await fetch(`${API_URL}/web/all_msg_counts/`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      // 2. Stop hitting the API immediately if unauthorized (Session Expired/Logged out)
      if (response.status === 401 || response.status === 403) {
        clearInterval(interval);
        return;
      }

      if (response.ok) {
        const data = await response.json();
        if (data && typeof data.count === "number") {
          setGlobalChatCount((prevCount) => {
            if (prevCount !== null && data.count > prevCount) {
              audioRef.current.currentTime = 0;
              audioRef.current.play().catch(console.error);
              window.dispatchEvent(new CustomEvent("newChatMessage"));
            }
            return data.count;
          });
        }
      }
    } catch (error) {
      console.error("Chat count fetch error:", error);
    }
  };

  // Run immediately once, then start the interval
  fetchChatCount();
  interval = setInterval(fetchChatCount, 3000);

  // Cleanup on unmount
  return () => clearInterval(interval);
}, []);

  // ==========================================
  // 🧑‍💼 USER GROUP VERIFICATION
  // ==========================================
  const [isLoggIn, setIsLoggIn] = useState(
    localStorage.getItem("user_group")
      ? localStorage.getItem("user_group") === "true"
      : false,
  );

  useEffect(() => {
    const userGroup = localStorage.getItem("user_group");
    setIsLoggIn(userGroup === "hr");
  }, []);

  // ==========================================
  // 🔗 LINK STATUS VALIDATION (EVENT ID)
  // ==========================================
  const [linkStatus, setLinkStatus] = useState("loading"); // "loading" | "valid" | "expired" | "notFound" | "error"
  const [eventID, setEventID] = useState(null);
  const [linkExpired, setLinkExpired] = useState(false);

  const checkServiceStatus = async (id) => {
    try {
      const response = await fetch(
        `${API_URL}/web/is_service_cancelled/${id}/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log("API Response:", data);

      if (data.message === "form already submitted") {
        setLinkExpired("submitted");
      } else if (data.status === "Does not exist") {
        setLinkExpired("notFound");
      } else if (data.status === true) {
        setLinkExpired(false); // Show the form
      } else {
        setLinkExpired(true); // The link has expired
      }
    } catch (error) {
      console.error("Error hitting API:", error);
      setLinkExpired(true);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const id = params.get("event_id");
    console.log("Extracted Event ID:", id);

    if (id) {
      setEventID(id);
      checkServiceStatus(id);
    } else {
      setLinkStatus("notFound");
    }
  }, []);

  useEffect(() => {
    setLinkExpired(false);
  }, []);

  // ==========================================
  // 🔐 GLOBAL 403 SESSION EXPIRATION MODAL
  // ==========================================
  const [isSessionExpired, setIsSessionExpired] = useState(false);

 useEffect(() => {
    const handleSessionExpired = () => {
      
      if (window.location.pathname !== "/") {
        setIsSessionExpired(true); 
      }
    };
    window.addEventListener("session-expired", handleSessionExpired);

    return () => {
      window.removeEventListener("session-expired", handleSessionExpired);
    };
  }, []);

const handleLoginRedirect = () => {
    localStorage.clear(); 
    setIsSessionExpired(false);
    window.location.href = "/"; 
  };
useEffect(() => {
    const loginTime = localStorage.getItem("loginTime");
    
  
    if (!loginTime || window.location.pathname === "/") return;

    const EIGHT_HOURS = 8 * 60 * 60 * 1000;

    // const EIGHT_HOURS = 60 * 1000;
    const remainingTime = EIGHT_HOURS - (Date.now() - Number(loginTime));

const logoutUser = async () => {
  try {
    const selectedExtension = localStorage.getItem("selected_extension");
    const isCloudValue =
      String(selectedExtension) === "1111" ? "False" : "True";

    await fetch(`${API_URL}/web/logout/`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        refresh: localStorage.getItem("refresh"),
        clg_id: localStorage.getItem("clg_id"),
        extension_id: selectedExtension || "",
        is_cloud: isCloudValue,
      }),
    });
  } catch (error) {
    console.log(error);
  }

 

  localStorage.clear();

  if (window.location.pathname !== "/") {
    window.location.href = "/"; 
  }
};

    if (remainingTime <= 0) {
      logoutUser();
    } else {
      const timer = setTimeout(logoutUser, remainingTime);
      return () => clearTimeout(timer);
    }
  }, []);


  useEffect(() => {
    window.history.pushState(null, null, window.location.href);
    const handleBackButton = () => {
      window.history.pushState(null, null, window.location.href);
    };
    window.addEventListener("popstate", handleBackButton);
    return () => window.removeEventListener("popstate", handleBackButton);
  }, []);

  return (
    <div className="App">
      <BrowserRouter basename="">
        <div>
          <Routes>
            {/* --- Login / Default --- */}
            <Route exact path="/" element={<Loginextentions />} />
            <Route path="/hhc/user" element={<UserDetails />} />
            <Route path="/consent" element={<ConsentDetails />} />
            <Route path="*" element={<NotFound />} />

            {/* --- HD Module Routes --- */}
            <Route
              exact
              path="/dashboard"
              element={isLoggedIn ? <HD_Dashboard /> : <Loginextentions />}
            />
            <Route
              exact
              path="/addservice"
              element={isLoggedIn ? <Addservice /> : <Loginextentions />}
            />
            <Route
              exact
              path="/viewservice"
              element={isLoggedIn ? <Viewservice /> : <Loginextentions />}
            />
            <Route
              exact
              path="/ongoing"
              element={isLoggedIn ? <Ongoingservice /> : <Loginextentions />}
            />
            <Route
              exact
              path="/professional"
              element={isLoggedIn ? <Schedule /> : <Loginextentions />}
            />
            <Route
              exact
              path="/service-request"
              element={isLoggedIn ? <ServiceRequest /> : <Loginextentions />}
            />
            <Route
              exact
              path="/enquiries"
              element={isLoggedIn ? <Enquiries /> : <Loginextentions />}
            />
            <Route
              path="/prof-req"
              element={isLoggedIn ? <ProfRequest /> : <Loginextentions />}
            />
            <Route
              path="/shift-handover"
              element={isLoggedIn ? <ShiftHandover /> : <Loginextentions />}
            />
            <Route
              exact
              path="/membership"
              element={isLoggedIn ? <Membership /> : <Loginextentions />}
            />

            {/* --- Consultant --- */}
            <Route
              exact
              path="/consultantLogin"
              element={isLoggedIn ? <ConsultantLogin /> : <ConsultantLogin />}
            />
            <Route
              path="hhc/consultant/referred patient details"
              element={<ReferredPatientDetails />}
            />
            <Route
              path="hhc/consultant/referred patient"
              element={<ReferredPatient />}
            />
            <Route
              path="consultant/referred patient details"
              element={<ReferredPatientDetails />}
            />
            <Route
              path="consultant/referred patient"
              element={<ReferredPatient />}
            />

            {/* --- ADMIN Dashboard & Base --- */}
            <Route path="/hhc/dashboard" element={<MDashboard />} />
            <Route path="/hhc/permission" element={<Permission />} />

            {/* --- ADMIN Reports Routes --- */}
            <Route path="/hhc/reports" element={<AdminReport />} />
            <Route
              path="/hhc/reports/enquiry report"
              element={<EnquiryReport />}
            />
            <Route
              path="/hhc/reports/consultant report"
              element={<ConsultantReport />}
            />
            <Route
              path="/hhc/reports/hospital report"
              element={<HospitalReport />}
            />
            <Route
              path="/hhc/reports/monthly report"
              element={<MonthlyReport />}
            />
            <Route
              path="/hhc/reports/payment cancellation report"
              element={<PaymentCancellation />}
            />
            <Route
              path="/hhc/reports/refund amount report"
              element={<RefundAmount />}
            />
            <Route
              path="/hhc/reports/job closure report"
              element={<JobClosure />}
            />
            <Route
              path="/hhc/reports/consent form report"
              element={<ConsentForm />}
            />
            <Route
              path="/hhc/reports/Refund Report"
              element={<RefundReports />}
            />
            <Route
              path="/hhc/reports/Clinical Governance Report"
              element={<ClinicalReports />}
            />
            <Route
              path="/hhc/reports/Patient feedback report"
              element={<PatientFeedbackReport />}
            />
            <Route
              path="/hhc/reports/Professional feedback report"
              element={<ProfessionalFeedbackReport />}
            />
            <Route
              path="/hhc/reports/Long Term Report"
              element={<LongTermReport />}
            />
            <Route
              path="/hhc/reports/shift-handover"
              element={<ShiftHandoverReport />}
            />

            {/* --- ADMIN HCM Routes --- */}
            <Route path="/hhc/HCM/manage service" element={<ManageService />} />
            <Route
              path="/hhc/hcm/patient blacklist"
              element={<Patientblacklist />}
            />
            <Route
              path="/hhc/HCM/manage hospital"
              element={<ManageHospital />}
            />
            <Route
              path="/hhc/HCM/manage feedback"
              element={<ManageFeedBack />}
            />
            <Route
              path="/hhc/HCM/manage payment cancellations"
              element={<ManagePayment />}
            />
            <Route
              path="/hhc/HCM/login employee"
              element={<LoginEmployees />}
            />
            <Route
              path="/hhc/HCM/professional allocation"
              element={<AllocatedList />}
            />
            <Route
              path="/hhc/HCM/professional details"
              element={<ProfessionalDetails />}
            />
            <Route path="/hhc/HCM/insurance" element={<Insurance />} />
            <Route
              path="/hhc/HCM/closure revalidation"
              element={<ClosureRevalidation />}
            />
            <Route
              path="/hhc/HCM/consultant management"
              element={<ConsultantList />}
            />
            <Route
              path="/hhc/HCM/manage consultant"
              element={<ManageConsultant />}
            />
            <Route path="/hhc/hcm/Long Term Form" element={<LongTearmForm />} />

            {/* --- ACCOUNT Routes (with and without /hhc prefix) --- */}
            <Route
              path="/hhc/account/dashboard"
              element={<AccountDashboard />}
            />
            <Route
              path="/hhc/account/new export receipt"
              element={<NewExportReceipt />}
            />
            <Route
              path="/hhc/account/export invoice"
              element={<ExportInvoice />}
            />
            <Route
              path="/hhc/account/payment with professional"
              element={<PaymentWithProfessional />}
            />
            <Route
              path="/hhc/account/payment with patient"
              element={<PaymentPatient />}
            />
            <Route
              path="/hhc/account/manage cashfree payment"
              element={<Cashfree />}
            />
            <Route
              path="/hhc/account/pending payment"
              element={<PendingPayment />}
            />
            <Route path="/hhc/account/day print" element={<DayPrintBHV />} />
            <Route
              path="/hhc/account/job closure report"
              element={<JobClosureAccount />}
            />
            <Route
              path="/hhc/account/professional unit calculation"
              element={<ProfessionalUnit />}
            />
            <Route
              path="/hhc/account/online transaction"
              element={<OnlineTransaction />}
            />
            <Route path="/hhc/account/payment utr" element={<PaymentUTR />} />

            <Route path="/account/dashboard" element={<AccountDashboard />} />
            <Route
              path="/account/new export receipt"
              element={<NewExportReceipt />}
            />
            <Route path="/account/export invoice" element={<ExportInvoice />} />
            <Route
              path="/account/payment with professional"
              element={<PaymentWithProfessional />}
            />
            <Route
              path="/account/payment with patient"
              element={<PaymentPatient />}
            />
            <Route
              path="/account/manage cashfree payment"
              element={<Cashfree />}
            />
            <Route
              path="/account/pending payment"
              element={<PendingPayment />}
            />
            <Route path="/account/day print" element={<DayPrintBHV />} />
            <Route
              path="/account/job closure report"
              element={<JobClosureAccount />}
            />
            <Route
              path="/account/professional unit calculation"
              element={<ProfessionalUnit />}
            />
            <Route
              path="/account/online transaction"
              element={<OnlineTransaction />}
            />
            <Route path="/account/payment utr" element={<PaymentUTR />} />

            {/* --- HR Module Routes (with and without /hhc prefix) --- */}
            <Route path="/hr/dashboard" element={<HRDashboard />} />
            <Route path="/hr/manage profiles" element={<ManageProfile />} />
            <Route
              path="/hr/manage profiles/add-prof"
              element={<AddProfessional />}
            />
            <Route path="/hr/interview scheduled" element={<Interview />} />
            <Route path="/hr/onboarding" element={<Candidates />} />
            <Route path="/hr/our employees" element={<Employee />} />
            <Route path="/hr/attendance" element={<Attendence />} />
            <Route path="/hr/system user" element={<SystemUser />} />
            <Route
              path="/hr/external professionals"
              element={<ExternalProf />}
            />
            <Route path="/hr/Care Coordinator" element={<CareCoordinator />} />
            <Route path="/hr/gis analytics" element={<Home />} />

            <Route path="hhc/hr/dashboard" element={<HRDashboard />} />
            <Route path="hhc/hr/manage profiles" element={<ManageProfile />} />
            <Route
              path="hhc/hr/manage profiles/add-prof"
              element={<ManageProfile />}
            />
            <Route path="hhc/hr/interview scheduled" element={<Interview />} />
            <Route path="hhc/hr/onboarding" element={<Candidates />} />
            <Route path="hhc/hr/our employees" element={<Employee />} />
            <Route path="hhc/hr/attendance" element={<Attendence />} />
            <Route
              path="hhc/hr/Care Coordinator"
              element={<CareCoordinator />}
            />
            <Route path="hhc/hr/system user" element={<SystemUser />} />
            <Route
              path="hhc/hr/external professionals"
              element={<ExternalProf />}
            />
            <Route path="hhc/gis analytics" element={<Home />} />

            {/* --- ATTENDANCE Module --- */}
            <Route
              path="/hhc/attendance/manage attendance"
              element={<ManageAttendance />}
            />
            <Route
              path="/hhc/attendance/attendance-dashboard"
              element={<AtteDashboard />}
            />
            <Route
              path="/hhc/attendance/manage report"
              element={<ManageReports />}
            />

            {/* --- Management & Dashboards --- */}
            <Route
              path="/management/management-dashboard"
              element={<ManagementDashboard />}
            />
            <Route
              path="hhc/dashboard/management dashboard"
              element={<ManagementDashboard />}
            />
            <Route
              path="hhc/dashboard/financial dashboard"
              element={<MM2Dashboard />}
            />
            <Route path="/analytics/home" element={<Home />} />
            <Route path="/MM2Dashboard" element={<MM2Dashboard />} />

            {/* --- Clinical Governance --- */}
            <Route exact path="/hhc/clinical" element={<Clinicalgov />} />
            <Route exact path="/hhc/ClinicalNew" element={<Clinicalgov />} />
            <Route
              exact
              path="/hhc/clinical governance"
              element={<Clinicalgov />}
            />

            {/* --- Hospital Module --- */}
            <Route path="/hospital/dashboard" element={<HospitalDashboard />} />

            {/* --- HR Partner Module --- */}
            <Route path="/hr partner/dashboard" element={<HrDashboard />} />
            <Route
              path="/hr partner/manage professionals"
              element={<ManageProfessionals />}
            />
            <Route
              path="/hr partner/Add professionals"
              element={<AddProfPartner />}
            />
            <Route
              path="/hr partner/service details"
              element={<Servicedetails />}
            />

            <Route path="hhc/hr partner/dashboard" element={<HrDashboard />} />
            <Route
              path="hhc/hr partner/manage professionals"
              element={<ManageProfessionals />}
            />
            <Route
              path="hhc/hr partner/Add professionals"
              element={<AddProfPartner />}
            />
            <Route
              path="hhc/hr partner/service details"
              element={<Servicedetails />}
            />

            {/* --- Refund & Physio --- */}
            <Route path="/hhc/refund" element={<Refund />} />
            <Route
              path="/hhc/Supervisor Visitor"
              element={<SupervisorVisitor />}
            />
            <Route path="/hhc/physio Quality Audit" element={<PhysioMiles />} />
            <Route path="/physioMilestone" element={<PhysioMiles />} />
            <Route path="/physio Quality Audit" element={<PhysioMiles />} />
            <Route path="/AddPhysioMiles" element={<AddPhysioMiles />} />

            {/* --- Payment Payout --- */}
            <Route
              path="/hhc/payment payout/prof request payout"
              element={<ProfRequestPayout />}
            />
            <Route
              path="/hhc/payment payout/process payout"
              element={<ProcessPayout />}
            />
            <Route
              path="/hhc/payment payout/approved payout list"
              element={<ApprovedPayoutList />}
            />
            <Route
              path="/hhc/payment payout/reports"
              element={<PaymentpayoutReport />}
            />

            {/* --- Privacy Policy & Terms --- */}
            <Route path="/TermsandConditions" element={<TermsCondition />} />
            <Route
              path="/CancellationRefundPolicy"
              element={<CancellationRefundPolicy />}
            />
            <Route path="/ContactInfo" element={<ContactInfo />} />
            <Route path="/About-Us" element={<AboutUs />} />

            {/* --- Long Term Form Logic --- */}
            <Route
              path="/long-term-form"
              element={
                linkExpired === false ? (
                  <>
                    {console.log(
                      "Rendering MedicalForm with eventID:",
                      eventID,
                    )}
                    <MedicalForm eventID={eventID} />
                  </>
                ) : linkExpired === "notFound" ? (
                  <Box
                    sx={{
                      minHeight: "100vh",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background:
                        "linear-gradient(135deg, rgba(245,247,250,1) 0%, rgba(230,240,245,1) 100%)",
                      px: 2,
                    }}
                  >
                    <Paper
                      elevation={4}
                      sx={{
                        p: { xs: 3, sm: 4 },
                        borderRadius: 3,
                        maxWidth: 400,
                        textAlign: "center",
                      }}
                    >
                      <ErrorOutlineIcon
                        sx={{
                          fontSize: { xs: 60, sm: 80 },
                          color: "error.main",
                          mb: 1,
                        }}
                      />
                      <Typography
                        variant="h6"
                        sx={{
                          color: "error.main",
                          fontWeight: 600,
                          fontSize: { xs: "16px", sm: "18px" },
                        }}
                      >
                        The requested service does not exist.
                      </Typography>
                    </Paper>
                  </Box>
                ) : linkExpired === "submitted" ? (
                  <Box
                    sx={{
                      minHeight: "100vh",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background:
                        "linear-gradient(135deg, rgba(245,247,250,1) 0%, rgba(230,240,245,1) 100%)",
                      px: 2,
                    }}
                  >
                    <Paper
                      elevation={4}
                      sx={{
                        p: { xs: 3, sm: 4 },
                        borderRadius: 3,
                        maxWidth: 400,
                        textAlign: "center",
                      }}
                    >
                      <BlockOutlinedIcon
                        sx={{
                          fontSize: { xs: 60, sm: 80 },
                          color: "warning.main",
                          mb: 1,
                        }}
                      />
                      <Typography
                        variant="h6"
                        sx={{
                          color: "warning.main",
                          fontWeight: 600,
                          fontSize: { xs: "16px", sm: "18px" },
                        }}
                      >
                        The form has already been submitted.
                      </Typography>
                    </Paper>
                  </Box>
                ) : (
                  <Box
                    sx={{
                      minHeight: "100vh",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background:
                        "linear-gradient(135deg, rgba(245,247,250,1) 0%, rgba(230,240,245,1) 100%)",
                      px: 2,
                    }}
                  >
                    <Paper
                      elevation={4}
                      sx={{
                        p: { xs: 3, sm: 4 },
                        borderRadius: 3,
                        maxWidth: 400,
                        textAlign: "center",
                      }}
                    >
                      <ErrorOutlineIcon
                        sx={{
                          fontSize: { xs: 60, sm: 80 },
                          color: "error.main",
                          mb: 1,
                        }}
                      />
                      <Typography
                        variant="h6"
                        sx={{
                          color: "error.main",
                          fontWeight: 600,
                          fontSize: { xs: "16px", sm: "18px" },
                        }}
                      >
                        The link has expired. The service has been cancelled.
                      </Typography>
                    </Paper>
                  </Box>
                )
              }
            />
            {/* <Route path="hhc/package/package list" element={<PackageList />} />
            <Route
              path="hhc/package/closure form builder"
              element={<PackageManagementList />}
            /> */}
          </Routes>
        </div>

        {/* ======================================================= */}
        {/* 🔥 SESSION EXPIRED MODAL RENDERED HERE */}
        {/* ======================================================= */}
        <Modal
          open={isSessionExpired && window.location.pathname !== "/"}
          style={{ zIndex: 99999 }}
          slotProps={{
            backdrop: {
              sx: {
                backdropFilter: "blur(5px)",
                backgroundColor: "rgba(15, 23, 42, 0.6)",
              },
            },
          }}
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: { xs: "85%", sm: 400 },
              bgcolor: "#ffffff",
              borderRadius: 4,
              boxShadow: "0px 20px 40px rgba(0,0,0,0.2)",
              p: 4,
              textAlign: "center",
              outline: "none",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            {/* Icon Container */}
            <Box
              sx={{
                width: 64,
                height: 64,
                borderRadius: "50%",
                bgcolor: "#fee2e2",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mb: 2.5,
              }}
            >
              <ErrorOutlineIcon sx={{ fontSize: 36, color: "#ef4444" }} />
            </Box>

            <Typography
              variant="h5"
              sx={{ fontWeight: 800, color: "#1e293b", mb: 1 }}
            >
              Session Expired
            </Typography>

            <Typography
              sx={{
                color: "#64748b",
                fontSize: "0.95rem",
                lineHeight: 1.5,
                mb: 4,
                px: 1,
              }}
            >
              For your security, your session has timed out due to inactivity.
              Please log in again to continue.
            </Typography>

            <Button
              variant="contained"
              fullWidth
              onClick={handleLoginRedirect}
              disableElevation
              sx={{
                bgcolor: "#2563eb",
                color: "white",
                py: 1.5,
                fontSize: "1.05rem",
                fontWeight: 600,
                borderRadius: 2.5,
                textTransform: "none",
                transition: "all 0.2s ease-in-out",
                "&:hover": {
                  bgcolor: "#1d4ed8",
                  transform: "translateY(-2px)",
                  boxShadow: "0 8px 16px rgba(37, 99, 235, 0.25)",
                },
              }}
            >
              Log In Again
            </Button>
          </Box>
        </Modal>
      </BrowserRouter>
    </div>
  );
}

export default App;
